import React, { useEffect, useState } from 'react';
import { Card, Form, Button, Row, Col } from 'react-bootstrap';
import Sidebar from './components/Sidebar';
import { UseData, displayUsername } from './components/Login-Sys';

function Gifts() {
  const [gifts, setGifts] = useState([]);
  const [users, setUsers] = useState([]);
  const [giftName, setGiftName] = useState('');
  const [recipient, setRecipient] = useState('');
  const [loadError, setLoadError] = useState(false);

  useEffect(() => {
    const fetchData = async () => {
      const [giftData, userData] = await Promise.all([
        UseData('get', 'gifts', {}, false),
        UseData('get', 'users', {}, false)
      ]);
      if (!Array.isArray(giftData) || !Array.isArray(userData)) {
        setLoadError(true);
        return;
      }
      setLoadError(false);
      setGifts(giftData);
      setUsers(userData);
      if (userData?.length) setRecipient(String(userData[0].id));
    };
    fetchData();
  }, []);

  async function handleSubmit(e) {
    e.preventDefault();
    const newGift = await UseData('post', 'gifts', {
      name: giftName.trim(),
      recipient: Number(recipient)
    });
    if (newGift?.id) setGifts(current => [...current, newGift]);
    setGiftName('');
  }

  return (
    <Sidebar>
      <div className="justify-content-center mb-3 text-center width-100">
        <h2 className="text-success">Lista Prezentów</h2>
        <hr />
        {loadError && <p className="text-danger">Nie udało się pobrać prezentów lub użytkowników. Sprawdź połączenie z serwerem.</p>}
        <Card className="bg-secondary-subtle border border-success-subtle mb-4 p-3">
          <Form onSubmit={handleSubmit}>
            <Row className="align-items-center">
              <Col xs={12} md={5} className="mb-2 mb-md-0">
                <Form.Control
                  type="text"
                  placeholder="Nazwa prezentu..."
                  value={giftName}
                  onChange={e => setGiftName(e.target.value)}
                  maxLength={256}
                  required
                />
              </Col>
              <Col xs={12} md={4} className="mb-2 mb-md-0">
                <Form.Select value={recipient} onChange={e => setRecipient(e.target.value)} required>
                  {users.map(user => <option key={user.id} value={user.id}>{displayUsername(user.username)}</option>)}
                </Form.Select>
              </Col>
              <Col xs={12} md={3}>
                <Button type="submit" variant="success" className="w-100" disabled={!users.length}>Dodaj</Button>
              </Col>
            </Row>
          </Form>
        </Card>

        <Card className="text-center text-success bg-secondary-subtle border border-success-subtle mb-4">
          <Card.Body>
            {users.map(user => {
              const userGifts = gifts.filter(item => Number(item.recipient) === Number(user.id));
              return (
                <div key={user.id} className="text-start mb-3">
                  <h3 className="my-2">{displayUsername(user.username)}:</h3>
                  {userGifts.length > 0 ? (
                    <ul className="mb-2">
                      {userGifts.map(item => <li key={item.id}>{item.name}</li>)}
                    </ul>
                  ) : null}
                  <hr />
                </div>
              );
            })}
            {!loadError && users.length === 0 && <Card.Text className="fs-5">Brak użytkowników w grupie „Rodzinny”</Card.Text>}
          </Card.Body>
        </Card>
      </div>
    </Sidebar>
  );
}

export default Gifts;
